/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Unsavedchanges_Stay1Inputs */

const en_common_unsavedchanges_stay1 = /** @type {(inputs: Common_Unsavedchanges_Stay1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay on page`)
};

/**
* | output |
* | --- |
* | "Stay on page" |
*
* @param {Common_Unsavedchanges_Stay1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_unsavedchanges_stay1 = /** @type {((inputs?: Common_Unsavedchanges_Stay1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Unsavedchanges_Stay1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_unsavedchanges_stay1(inputs)
});
export { common_unsavedchanges_stay1 as "common_unsavedChanges_stay" }